import * as React from "react";
import usePermissions from "hooks/usePermissions";
import { STEP_READABLE_ACTION_TYPES } from "security-app/components/SecurityEvents/EventProcedures/plugin/StepList/StepActionsButton";
import StepActionButton from "./StepActionButton";
function StepPerformSearch({ config, actionUrl }) {
  const { saved_search } = config;
  const { isPermitted } = usePermissions();
  const disabled = saved_search && !isPermitted(`view:read:${saved_search}`);
  return /* @__PURE__ */ React.createElement(
    StepActionButton,
    {
      hint: disabled ? "You don't have access to see this saved search" : void 0,
      title: STEP_READABLE_ACTION_TYPES.perform_search,
      to: disabled ? null : actionUrl,
      disabled
    }
  );
}
export default StepPerformSearch;
